import SchoolAddress from "../../types/core/SchoolAddress";

class School {
    id: number;
    key: string;
    name: string;
    logoFile: string;
    timezone: string;
    expiryMonth: number;
    authenticationMode: string;
    authenticationDomain: string;
    address: SchoolAddress;
    status: boolean;
    requireTwoFactor: boolean;
    requireTwoFactorFido2: boolean;

    constructor(data?: Partial<School>) {
        Object.assign(this, data);

        if (data.address)
            this.address = new SchoolAddress(data.address);
    }
}

export default School;